module.exports = __webpack_public_path__ + "static/media/basketball.49fac130.jpg";